import datos from "src/services/datos";
import "src/services/styles/sweetAlert.css"
import esArray from "src/general_components/functionEsArray";


export const getEstantesUbicaciones = async (auth) => {

    const estantes = new datos("estantes");

    const response = await estantes.getEstantes();
    const arrResponse = esArray(response.wsResponse?.estantes)
    return arrResponse;
};

export const getEstantesUbicacionesPaginated = async (limit, offset, conditions) => {

    const estantes = new datos("estantes");

    const response = await estantes.getEstantes(limit, offset, conditions);
    console.log("response", response);
    let result = {};
    if (!response.wsResponse.empty) {
        let arrResponse = esArray(response.wsResponse.estantes)
        result = {
            data: arrResponse,
            total_records: response.wsResponse.total_records,
        };
        return result;
    }else{
        result = {
            data: [],
            total_records: 0,
        };
        return result;
    }

};

function reemplazarObjetosPorId(data) {
    // Verificar si el dato es un objeto
    if (typeof data === 'object' && data !== null) {
        // Recorrer cada propiedad del objeto
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                // Verificar si la propiedad es un objeto y tiene una propiedad "id"
                if (typeof data[key] === 'object' && data[key] !== null && 'id' in data[key]) {
                    // Reemplazar el objeto por su propiedad "id"
                    data[key] = data[key].id;
                } else {
                    // Si la propiedad no es un objeto con "id", llamar recursivamente a la función
                    reemplazarObjetosPorId(data[key]);
                }
            }
        }
    }
    // Devolver el objeto modificado
    return data;
}


export const setEstantes = async (modelo, datosForm) => {
    console.log("datosForm", datosForm)
    const data = reemplazarObjetosPorId(datosForm);

    const objeto = new datos(modelo);
    if (data.fecha) {
        const fechaParseada = new Date(data.fecha);

        // Formatear la fecha según el formato deseado (por ejemplo, 'YYYY-MM-DD HH:mm:ss')
        const fechaFormateada = `${fechaParseada.getFullYear()}-${(fechaParseada.getMonth() + 1).toString().padStart(2, '0')}-${fechaParseada.getDate().toString().padStart(2, '0')} ${fechaParseada.getHours().toString().padStart(2, '0')}:${fechaParseada.getMinutes().toString().padStart(2, '0')}:${fechaParseada.getSeconds().toString().padStart(2, '0')}`;

        const objetoFormateado = {
            ...data,
            fecha: fechaFormateada
        };
        const response = await objeto.setEstantes(objetoFormateado);
        return response;
    }
    const response = await objeto.setEstantes(data);
    return response;

};

